import { collectEvent, UserAction, userActionTypeEnum, } from '@thoughtspot/metrics';
import { Icon, IconColor, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { getPrincipalObjectExportLimit } from '@thoughtspot/session-service';
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
export var ImportTslPath;
(function (ImportTslPath) {
    ImportTslPath["USER_GROUP"] = "/import-tsl/USER_GROUP";
    ImportTslPath["USER"] = "/import-tsl/USER";
    ImportTslPath["ROLE"] = "/import-tsl/ROLE";
})(ImportTslPath || (ImportTslPath = {}));
export const MODE = {
    UPDATE: 'UPDATE',
    ADD: 'ADD',
    DELETE: 'DELETE',
    ASSIGN_USERS_GROUPS: 'ASSIGN_USERS_GROUPS',
    IMPORT: 'IMPORT',
    EXPORT: 'EXPORT',
    ASSIGN_USERS_ORG: 'ASSIGN_USERS_ORG',
    RESET_MFA: 'RESET_MFA',
    RESET_PASSWORD: 'RESET_PASSWORD',
    RESEND_ACTIVATION: 'RESEND_ACTIVATION',
};
export const SHARING_VISIBILITY = {
    DEFAULT: 'DEFAULT',
    NON_SHARABLE: 'NON_SHARABLE',
};
export const CHECKBOX_SECTION_PAGINATION_BATCHSIZE = 100;
export const renderFormFieldValue = (fieldValue, isUpdated, containerCss, value, isLabelHeaderRequired = true, isDeleted = false, styles) => (React.createElement(Vertical, null,
    isLabelHeaderRequired && (React.createElement(Typography, { variant: "p-bold", overrideTag: "div" }, fieldValue)),
    isUpdated ? (React.createElement(Horizontal, { className: containerCss },
        isDeleted ? (React.createElement(Icon, { id: IconID.CROSS, size: IconSize.SMALL, color: IconColor.RED })) : (React.createElement(Icon, { id: IconID.CHECKMARK, size: IconSize.SMALL })),
        React.createElement(Typography, { variant: "p", overrideTag: "div" }, value))) : (React.createElement(Horizontal, { className: styles.reviewExistingName },
        React.createElement(Icon, { id: IconID.CIRCLE, size: IconSize.SMALL, className: styles.reviewIconSize }),
        React.createElement(Typography, { variant: "p", overrideTag: "div" }, value)))));
export const renderItemForReview = (key, label, containerCss, iconId, isFirst = false, isLast = false, styles, iconCss) => (React.createElement(Horizontal, { key: key, className: cx(styles[containerCss], {
        [styles.firstItem]: isFirst,
        [styles.lastItem]: isLast,
    }) },
    React.createElement(Icon, { id: iconId, size: IconSize.SMALL, className: iconCss || null }),
    React.createElement(Typography, { variant: "p", overrideTag: "div" }, label)));
const renderReviewCheckboxItems = (originalList, filteredData, preSelectedPrivilegeIdsInMap, styles, isEditMode = false) => {
    const existingSelectedPrivileges = [];
    let newlyAddedPrivileges = filteredData;
    let removedPrivileges = [];
    let isOnlyRemove = false;
    let isMixedRemove = false;
    if (isEditMode) {
        newlyAddedPrivileges = [];
        filteredData.forEach(({ id, name }) => {
            if (preSelectedPrivilegeIdsInMap.has(id)) {
                existingSelectedPrivileges.push({ id, name });
            }
            else {
                newlyAddedPrivileges.push({ id, name });
            }
        });
        const existingSelectedPrivilegesMap = new Set(existingSelectedPrivileges.map(({ id }) => id));
        const previouslySelected = originalList.filter((data) => preSelectedPrivilegeIdsInMap.has(data.id));
        removedPrivileges = previouslySelected.filter((data) => !existingSelectedPrivilegesMap.has(data.id));
        isOnlyRemove =
            _.isEmpty(newlyAddedPrivileges) &&
                _.isEmpty(existingSelectedPrivileges) &&
                !_.isEmpty(removedPrivileges);
        isMixedRemove = !_.isEmpty(removedPrivileges);
    }
    const newlyAddedPrivilegesLength = newlyAddedPrivileges.length;
    const existingSelectedPrivilegesLength = existingSelectedPrivileges.length;
    const removedPrivilegesLength = removedPrivileges.length;
    return (React.createElement(Horizontal, { className: styles.reviewPrivilegeMainContainer },
        !isOnlyRemove && (React.createElement(Vertical, { className: styles.reviewPrivilegeLeftContainer },
            newlyAddedPrivileges.map((item, index) => renderItemForReview(item.id, item.displayName || item.name, 'reviewPrivilegeItem', IconID.CHECKMARK, index === 0, index === newlyAddedPrivilegesLength - 1, styles)),
            existingSelectedPrivileges.map((item, index) => renderItemForReview(item.id, item.displayName || item.name, 'reviewExitingPrivilegeItem', IconID.CIRCLE, index === 0, index === existingSelectedPrivilegesLength - 1, styles, styles.reviewIconSize)))),
        React.createElement(Vertical, { className: styles.reviewPrivilegeRightContainer }, isMixedRemove &&
            removedPrivileges.map((item, index) => renderItemForReview(item.id, item.displayName || item.name, 'reviewPrivilegeItem', IconID.CROSS, index === 0, index === removedPrivilegesLength - 1, styles)))));
};
const renderOrgsReviewCheckboxItems = (originalList, filteredData, preSelectedOrgIdsInMap, styles, isEditMode = false) => {
    const existingSelectedPrivileges = [];
    let newlyAddedOrgs = filteredData;
    let removedOrgs = [];
    let isOnlyRemove = false;
    let isMixedRemove = false;
    if (isEditMode) {
        newlyAddedOrgs = [];
        filteredData.forEach(({ orgId, orgName }) => {
            if (preSelectedOrgIdsInMap.has(orgId)) {
                existingSelectedPrivileges.push({ orgId, orgName });
            }
            else {
                newlyAddedOrgs.push({ orgId, orgName });
            }
        });
        const existingSelectedPrivilegesMap = new Set(existingSelectedPrivileges.map(({ orgId }) => orgId));
        const previouslySelected = originalList.filter((data) => preSelectedOrgIdsInMap.has(data.orgId));
        removedOrgs = previouslySelected.filter((data) => !existingSelectedPrivilegesMap.has(data.orgId));
        isOnlyRemove =
            _.isEmpty(newlyAddedOrgs) &&
                _.isEmpty(existingSelectedPrivileges) &&
                !_.isEmpty(removedOrgs);
        isMixedRemove = !_.isEmpty(removedOrgs);
    }
    const newlyAddedOrgsLength = newlyAddedOrgs.length;
    const existingSelectedPrivilegesLength = existingSelectedPrivileges.length;
    const removedOrgsLength = removedOrgs.length;
    return (React.createElement(Horizontal, { className: styles.reviewPrivilegeMainContainer },
        !isOnlyRemove && (React.createElement(Vertical, { className: styles.reviewPrivilegeLeftContainer },
            newlyAddedOrgs.map((item, index) => renderItemForReview(item.orgId, item.orgName, 'reviewPrivilegeItem', IconID.CHECKMARK, index === 0, index === newlyAddedOrgsLength - 1, styles)),
            existingSelectedPrivileges.map((item, index) => renderItemForReview(item.orgId, item.orgName, 'reviewExitingPrivilegeItem', IconID.CIRCLE, index === 0, index === existingSelectedPrivilegesLength - 1, styles, styles.reviewIconSize)))),
        React.createElement(Vertical, { className: styles.reviewPrivilegeRightContainer }, isMixedRemove &&
            removedOrgs.map((item, index) => renderItemForReview(item.orgId, item.orgName, 'reviewPrivilegeItem', IconID.CROSS, index === 0, index === removedOrgsLength - 1, styles)))));
};
const reviewCheckboxList = (groupLabel, filteredData, preSelectedIdsInMap, originalList, styles, isEditMode) => {
    return (React.createElement(Vertical, { className: styles.reviewPrivilegeGroupContainer },
        React.createElement(Vertical, null,
            React.createElement(Vertical, null,
                React.createElement(Typography, { variant: "p-bold", overrideTag: "div" }, groupLabel)),
            renderReviewCheckboxItems(originalList, filteredData, preSelectedIdsInMap, styles, isEditMode))));
};
const reviewOrgsCheckboxList = (groupLabel, filteredData, preSelectedIdsInMap, originalList, styles, isEditMode) => {
    return (React.createElement(Vertical, { className: styles.reviewPrivilegeGroupContainer },
        React.createElement(Vertical, null,
            React.createElement(Vertical, null,
                React.createElement(Typography, { variant: "p-bold", overrideTag: "div" }, groupLabel)),
            renderOrgsReviewCheckboxItems(originalList, filteredData, preSelectedIdsInMap, styles, isEditMode))));
};
export const renderCheckboxListReview = (groupLabel, preSelectedIds, originalList, checkedItems, styles, isEditMode) => {
    const preSelectedIdsInMap = new Set(preSelectedIds);
    const filteredData = originalList.filter((item) => checkedItems.has(item.id));
    return reviewCheckboxList(groupLabel, filteredData, preSelectedIdsInMap, originalList, styles, isEditMode);
};
export const renderOrgsCheckboxListReview = (groupLabel, preSelectedIds, originalList, checkedItems, styles, isEditMode) => {
    const preSelectedIdsInMap = new Set(preSelectedIds);
    const filteredData = originalList.filter((item) => checkedItems.has(item.orgId));
    return reviewOrgsCheckboxList(groupLabel, filteredData, preSelectedIdsInMap, originalList, styles, isEditMode);
};
export const updateRowData = (rowData, selectedRowsIds, setRowData) => {
    let updatedRowData = rowData;
    if (selectedRowsIds.length) {
        updatedRowData = rowData.map((row) => {
            return { ...row, ...{ isChecked: true } };
        });
    }
    else {
        updatedRowData = rowData.map((row) => {
            return { ...row, ...{ isChecked: false } };
        });
    }
    setRowData(updatedRowData);
};
export const refreshCells = (gridRef, rowIds, colId) => {
    const rowNodes = rowIds.map((id) => gridRef.current.getRowNode(id));
    gridRef.current.refreshCells({
        rowNodes: [...rowNodes],
        columns: [colId],
    });
};
export const getErrorCode = (err) => {
    if (_.isArray(err)) {
        return (err[0]?.errorObj?.extensions?.exception?.upstreamResponse?.data
            ?.code || '');
    }
    return (err?.networkError?.result?.errors[0]?.extensions?.exception
        ?.upstreamResponse?.data?.code || '');
};
export const getErrorTraceId = (err) => {
    if (_.isArray(err)) {
        return (err[0]?.errorObj?.extensions?.exception?.upstreamResponse?.data
            ?.trace_id_guid || '');
    }
    return (err?.networkError?.result?.errors[0]?.extensions?.exception
        ?.upstreamResponse?.data?.trace_id_guid || '');
};
export const getErrorIncidentId = (err) => {
    if (_.isArray(err)) {
        return (err[0]?.errorObj?.extensions?.exception?.upstreamResponse?.data
            ?.incident_id_guid || '');
    }
    return (err?.networkError?.result?.errors[0]?.extensions?.exception
        ?.upstreamResponse?.data?.incident_id_guid || '');
};
export const getFailureEventProps = (userActionName, err, errorMessage) => {
    return {
        failureUserAction: userActionName,
        failureTimestamp: new Date().getTime(),
        failureCodeNumber: getErrorCode(err),
        failureTraceId: getErrorTraceId(err),
        failureIncidentId: getErrorIncidentId(err),
        failureMessage: errorMessage,
    };
};
export const captureFailureEvent = (userActionName, err, errorMessage) => {
    const failureEvent = new UserAction(userActionTypeEnum.FAILURE_ALERT);
    collectEvent(failureEvent, getFailureEventProps(userActionName, err, errorMessage));
};
export const getLabelWithOrWithOutErrorIcon = (clsName, hasError, label, subLabel = '') => {
    return (React.createElement(Horizontal, { className: clsName },
        hasError && (React.createElement(Icon, { color: IconColor.RED, size: IconSize.XSMALL, id: IconID.EXCLAMATION_POINT_CIRCLE })),
        label,
        subLabel ? (React.createElement(Typography, { variant: "footnote", overrideTag: "span", color: hasError ? Colors.failure : Colors.grayLight },
            "(",
            subLabel,
            ")")) : null));
};
export const deepOmit = (obj, keysToOmit) => {
    if (_.isObject(obj) && !_.isArray(obj)) {
        return _.reduce(obj, (result, value, key) => {
            if (!keysToOmit.includes(key)) {
                result[key] = deepOmit(value, keysToOmit);
            }
            return result;
        }, {});
    }
    else if (_.isArray(obj)) {
        return obj.map(item => deepOmit(item, keysToOmit));
    }
    return obj;
};
export const getCurrentPageIds = (data) => {
    return data && data.length !== 0
        ? data.map((obj) => obj?.id ?? '')
        : [];
};
export const getSelectedOnCurrentPage = (selectedRowsIds, data) => {
    const currentIds = getCurrentPageIds(data);
    return selectedRowsIds.filter((value) => currentIds.includes(value));
};
export const isExportObjectLimitReached = (ids) => {
    return ids.length > getPrincipalObjectExportLimit();
};
export const onRowsSelectAction = (rowIds, data, listInput, lastOperatedPage, setLastOperatedPage, selectedRowsIds, setSelectedRowsIds) => {
    if (!data?.length)
        return;
    const filteredSelectedRowIds = getSelectedOnCurrentPage(selectedRowsIds, data);
    if (_.isEqual(rowIds, filteredSelectedRowIds)) {
        if (listInput?.offset !== undefined && listInput?.offset !== null) {
            setLastOperatedPage(listInput.offset);
        }
        return;
    }
    if (listInput?.offset !== undefined &&
        listInput.offset !== lastOperatedPage &&
        !rowIds.length) {
        if (listInput?.offset !== null) {
            setLastOperatedPage(listInput.offset);
        }
        return;
    }
    const currentSelected = selectedRowsIds.filter((value) => !filteredSelectedRowIds.includes(value));
    currentSelected.push(...rowIds);
    setSelectedRowsIds(currentSelected);
    if (listInput?.offset !== undefined && listInput?.offset !== null) {
        setLastOperatedPage(listInput.offset);
    }
};
//# sourceMappingURL=util.js.map